// extracted by mini-css-extract-plugin
export var active = "sectionnav-block-module--active--Q8GlV";
export var navItem = "sectionnav-block-module--navItem--1W-HU";
export var nonActive = "sectionnav-block-module--nonActive--Cjnxf";
export var subtitle = "sectionnav-block-module--subtitle--5CCaT";
export var title = "sectionnav-block-module--title--eIQYw";